import { render } from "./ItemHistoryModal.vue?vue&type=template&id=648aa61e&scoped=true"
import script from "./ItemHistoryModal.vue?vue&type=script&lang=js"
export * from "./ItemHistoryModal.vue?vue&type=script&lang=js"

import "./ItemHistoryModal.vue?vue&type=style&index=0&id=648aa61e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648aa61e"]])

export default __exports__